class CardSwatches extends HTMLElement {
    constructor() {
        super();
        this.thumbnailsWrapper = this.querySelector('.card-swatches__thumbnails')
        this.thumbnails = Array.from(this.querySelectorAll('.swatch-element'))
        
        this.cardWrapper = this.closest('.card-wrapper')
        if(this.cardWrapper) this.regularPriceElement = this.cardWrapper.querySelector('.price .price-item--regular')
        if(this.cardWrapper) this.salePriceElement = this.cardWrapper.querySelector('.price .price-item--sale')        
        if(this.cardWrapper) this.productImage = this.cardWrapper.querySelector('.media img')
        if(this.cardWrapper) this.swatchTitleName = this.cardWrapper.querySelector('.finish-name')

        this.thumbnails.map(swatch => swatch.addEventListener('click', this.swatchSelect.bind(this)))
    }
    swatchSelect(event) {
        event.preventDefault()
        event.stopPropagation()
        this.selectedSwatch = event.target
        this.selectedSwatchLabel = this.selectedSwatch.closest('label')
        this.selectedSwatchWrapper = this.selectedSwatch.closest('.swatch-element')
       
        if(this.selectedSwatchLabel) {
            this.activeSwatch = this.querySelector('label.active-swatch')
            if(this.activeSwatch) this.activeSwatch.classList.remove('active-swatch')
            this.selectedSwatchLabel.classList.add('active-swatch')
        }
        if(this.selectedSwatchWrapper) {
            
            const swatchTitle = this.selectedSwatchWrapper.dataset.swatchTitle
            const swatchImageUrl = this.selectedSwatchWrapper.dataset.image
            const swatchPrice = this.selectedSwatchWrapper.dataset.price
            const swatchComparePrice = this.selectedSwatchWrapper.dataset.comparePrice

            // TITLE UPDATE 
            if(this.swatchTitleName) this.swatchTitleName.innerText = swatchTitle
            
            // IMAGE UPDATE           
            if(this.productImage && !swatchImageUrl.includes('no-image')) {
                if(swatchImageUrl) {
                    var newSrcset = `${swatchImageUrl} 165w, ${swatchImageUrl} 720w, ${swatchImageUrl} 1243w`
               
                    this.productImage.setAttribute('srcset', newSrcset);
                }
                
            }
             
            // PRICE UPDATE
            if(swatchComparePrice !== '0.00') {
                if(swatchComparePrice !== '') {
                    if(this.salePriceElement) this.salePriceElement.innerText = swatchPrice
                    if(this.regularPriceElement) this.regularPriceElement.innerText = swatchComparePrice
                }                
            }else {
                if(this.regularPriceElement) this.regularPriceElement.innerText = swatchPrice
            }
           
        }
        
    }
}
customElements.define('card-swatches', CardSwatches);